import React, { useReducer } from "react"
import { splitGoalName } from "../helpers/helpers"

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialState = {
  activeGoal: null,
  activeSubGoal: null,
  lightMode: false,
  infoColOffset: 0,
  circleColOffset: 0,
  showHelpOverlay: false,
  showImprintOverlay: false,
}

function reducer(state, action) {
  switch (action.type) {
    case "SELECT_GOAL": {
      return {
        ...state,
        activeGoal: action.goal,
        activeSubGoal: null,
      }
    }

    case "SELECT_SUB_GOAL": {
      return {
        ...state,
        activeGoal: splitGoalName(action.subGoal)[0],
        activeSubGoal: action.subGoal,
      }
    }

    case "TOGGLE_LIGHT_MODE": {
      return {
        ...state,
        lightMode: !state.lightMode,
      }
    }

    case "SET_INFO_COL_OFFSET": {
      return {
        ...state,
        infoColOffset: action.x,
      }
    }

    case "SET_CIRCLE_COL_OFFSET": {
      return {
        ...state,
        circleColOffset: action.x,
      }
    }

    case "SET_HELP_OVERLAY": {
      return {
        ...state,
        showHelpOverlay: action.showHelpOverlay,
      }
    }

    case "SET_IMPRINT_OVERLAY": {
      return {
        ...state,
        showImprintOverlay: action.showImprintOverlay,
      }
    }

    default:
      throw new Error("Bad Action Type")
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider
